import { ArrowDownDropCircleIcon } from './ArrowDownDropCircleIcon';

/**
 * author: Google
 * id 34BD0C0B-AF54-4BFC-A539-35D67612C4AC
 * name arrow-down-drop-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-drop-circle.svg
 * tags
 * - Arrow 
 */
export const ArrowDropDownCircleIcon = ArrowDownDropCircleIcon;
export default ArrowDropDownCircleIcon